import "./privacy-policy.scss";
import { Tooltip } from "antd";
import backarrow from "../../../assets/back-arrow.svg";
import { Link } from "react-router-dom";

const PrivacyPolicy = () => {
  return (
    <div className="container">
      <Tooltip placement="right" title={"Back to tools home"}>
        <Link to={"/home"}>
          <img alt="back arrow" className="sk2r-back-arrow" src={backarrow} />
        </Link>
      </Tooltip>
      <div className="row">
        <div
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <h1>Privacy Policy</h1>
          <p>
            We would like to be fully transparent with you. Although we promise
            not to sell your data to third parties, we might use it to improve
            the service and the AI. Data is what helps us improve, and the only
            thing we ask from you. The images uploaded to our site might be used
            to improve our machine learning models. Thank you for using Vizcom
            and in helping us build awesome design tools.
          </p>
          <p>
            We will collect and use of your data solely for the purpose of
            improving our website. By using this site, you agree to the
            collection and use of information in accordance with this policy.
          </p>
          <p>
            We will not use or share your data with anyone except as described
            in this privacy policy.
          </p>
          <p>
            The names of any individuals created by or for the use of this site
            are not used in advertising or publicity pertaining to the web site.
          </p>
          <p>
            We will not use or share any information from this site with any
            other person or entity, except as described in this privacy policy.
          </p>
          <p>
            We will use reasonable efforts to remove or delete any information
            we believe has been collected in violation of this privacy policy,
            but in the event that we cannot do so, we will retain the
            information for at least 30 days.
          </p>
          <p>
            If you have any questions about this privacy policy, please contact
            us. You can contact us by email at{" "}
            <a href="mailto:contactvizcom@gmail.com">contactvizcom@gmail.com</a>
          </p>
          <h5>Data collected on the basis of consent</h5>
          <p>
            Upon your request and expression of consent, we collect the
            following data for the purpose of providing services to you. Your
            data is not used for any other purposes or shared with third
            parties. It is removed upon your withdrawal of consent or your
            request to terminate theses services.
          </p>
          <h5>data collected</h5>
          <p>
            Name, email address, images uploaded: this data is collected when
            you interact with vizcom.
          </p>
          <p>IP and browser user agent string</p>
          <p>
            Retention period: the aforementioned data is retained indefinitely
            so we can recognize improve the experience of our tools.
          </p>
          <h5>Data collected on the basis of legitimate interest</h5>
          <p>
            Based on our legitimate interests, we collect the following data for
            the purpose of running this website. Your data is not used for any
            other purposes or shared with third parties. It is removed upon your
            request.
          </p>
          <h5>Statistics</h5>
          <p>
            The website uses a minimal build of Google Analytics, a service
            which transmits website traffic data to Google servers in the United
            States and allows us to notice trends to improve the user experience
            on our website. This minimal build processes personal data such as:
            the unique User ID set by Google Analytics, the date and time, the
            title of the page being viewed, the URL of the page being viewed,
            the URL of the page that was viewed prior to the current page, the
            screen resolution, the time in local timezone, the files that were
            clicked on and downloaded, the links clicked on to an outside
            domain, the type of device, and the country, region, and city.
          </p>
          <p>
            You may opt out of this tracking at any time by activating the “Do
            Not Track” setting in your browser.
          </p>
          <h5>Your rights pertaining your data</h5>
          <p>
            If you have uploaded images on the Website, you can request to
            receive an exported file of the personal data we hold about you,
            including any data you have provided to us. You can also request
            that we rectify or erase any personal data we hold about you. Please
            send your request to contact@gmail.com
          </p>
          <ul>
            <li>The right to withdraw consent</li>
            <li>The right of access</li>
            <li>The right to erasure</li>
            <li>The right to rectification</li>
            <li>The right to data portability</li>
            <li>The right to object</li>
            <li> Notification of data breaches</li>
            <li>The right to lodge a complaint with a supervisory authority</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
